import { IMenuItem } from "interfaces";
import { IMenuAccess } from "interfaces/IMenuAccess";
import { getAgentMenuAccess } from "rbac";
import strings from "strings";
import { MenuList } from "types/menuList";

const agentMenuBar = () => {
  const agentMenuBarList: MenuList = {
    list1: [],
    list2: []
  };

  const menuList1: IMenuItem[] = [
    {
      name: strings.MENU.DASHBOARD,
      icon: 'icon_dashboard',
      id: 'dashboard',
    },
    {
      name: strings.MENU.CARRIERS,
      icon: 'icon_carrier',
      id: 'carriers',
    },
  ]

  const menuList2: IMenuItem[] = [
    {
      name: strings.MENU.HELP,
      icon: 'icon_help',
      id: 'help',
      url: 'https://truckercloud.zendesk.com/hc/en-us/requests/new?ticket_form_id=4415135008155',
    },
    {
      name: strings.MENU.PROFILE,
      icon: 'icon_profile',
      id: 'profile',
    }
  ]

  const agentMenuAccess: IMenuAccess[] = getAgentMenuAccess()
  agentMenuBarList.list1.push(...menuList1.filter((item: IMenuItem) => agentMenuAccess.some(accessItem => accessItem.name === item.name)))
  agentMenuBarList.list2.push(...menuList2.filter((item: IMenuItem) => agentMenuAccess.some(accessItem => accessItem.name === item.name)))

  return agentMenuBarList
}

export default agentMenuBar
